function round(val: number, places: number) {
  return Math.round(val * 10 ** places) / 10 ** places;
}

export default round;
